import { Block } from 'shared/components/Block';
import { CustomList } from 'shared/components/CustomList';
import { Description } from 'shared/components/Description';
import { SubTitle } from 'shared/components/SubTitle';
import { Title } from 'shared/components/Title';
import { Wrapper } from 'shared/components/Wrapper';
import { ENavigation } from 'shared/types/navigation';
import { FIRST_DESCR, SECOND_DESCR, LIST, UTP } from './constants';
import * as styles from './styles.css';
import { Element } from 'react-scroll';
import { clsx } from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

export const BaseModeration: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <Wrapper>
        <Element name={ENavigation.DatabaseModeration}>
          <Block>
            <Title text="Модерация базы" />
            <Description text={FIRST_DESCR} />
            <SubTitle text="Подход:" />
            <div className={styles['banners']}>
              {UTP.map(({ image, title, descr }, key) => (
                <div key={key} className={styles['banner']}>
                  <div className={styles['banner-textblock']}>
                    <div className={styles['banner-title']}>{title}</div>
                    <div className={styles['banner-descr']}>{descr}</div>
                  </div>
                  <div className={clsx(styles['banner-image'], styles[image])} />
                </div>
              ))}
            </div>
            <Description text={SECOND_DESCR} />
            <CustomList items={LIST} />
          </Block>
        </Element>
      </Wrapper>
    </div>
  );
};
